export default class Benefits {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        //this.prevWW = null;
        //this.mobile = false;
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
        }
    }

    getElements = () => {
      //Query your elements here
        this.benefits = this.passedElement.querySelectorAll('.benefit');
        //this.prevWW = window.innerWidth;
        //if (window.innerWidth < 760) this.mobile = true;
    }

    _removeOpenClasses = () => {
        this.benefits.forEach(elm => {
            elm.classList.remove('open');
        });
    }

    _openBenefit = (elm) => {
        //if (this.mobile) this._removeOpenClasses();
        this._removeOpenClasses()
        elm.classList.add('open');
    }

    addEventListeners = () => {
      //Add all event listeners bellow
        this.benefits.forEach(elm => {
            elm.addEventListener("click", e => {
                e.preventDefault();

                e.currentTarget.classList.contains('open') 
                ? e.currentTarget.classList.remove('open') 
                : this._openBenefit(e.currentTarget);
            })
        });
    
        window.addEventListener("resize", () => {
            // if ( this.prevWW > 760 && window.innerWidth < 760 ) {
            //     this.mobile = true;
            //     this._removeOpenClasses();
            // }
            // if ( this.prevWW < 760 && window.innerWidth > 760 ) {
            //     this.mobile = false;
            //     this._removeOpenClasses();
            // }
            this._removeOpenClasses();
            //this.prevWW = window.innerWidth;
        });
    
    }

}